import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class DataBaseService {
  urlDataBase: any = "https://lzu9u9n85a.execute-api.sa-east-1.amazonaws.com/v1/api";
  urlSite:any = "https://cliente.vivamax.com.br"
  apiSMS: any = "https://sk2ii4laei.execute-api.sa-east-1.amazonaws.com/v1/sms";
  apiConfiguracoes:any = this.urlDataBase+'/configuracoes';
  apiCredenciados:any = this.urlDataBase+'/credenciados';
  apiFormularios:any = this.urlDataBase+'/formularios';
  apiFinanceiro:any = this.urlDataBase+'/financeiro';
  apiAssociados:any = this.urlDataBase+'/associados';
  apiEmpresas:any = this.urlDataBase+'/empresas';
  apiPlanos:any = this.urlDataBase+'/planos';
  apiLogs:any = this.urlDataBase+'/logs';
  apiUsuarios:any = this.urlDataBase+'/usuarios';
  apiServidores:any = this.urlDataBase+'/servidores';
  nomeUsuario:any = localStorage.getItem('nomeUsuarioVM');
  emails:any = [];
  emailCancelamento:any = "";
  idCancelamento:any = "";
  responsavelCancelamento:any = "";
  emailSac:any = "";
  idSac:any = "";
  responsavelSac:any = "";
  emailReembolso:any = "";
  idReembolso:any = "";
  responsavelReembolso:any = "";
  emailSeguro:any = "";
  idSeguro:any = "";
  responsavelSeguro:any = "";
  emailDependentes:any = "";
  idDependentes:any = "";
  responsavelDependentes:any = "";
  emailCarteirinhas:any = "";
  idCarteirinhas:any = "";
  responsavelCarteirinhas:any = "";
  servicosContratados:any = [];
  idServidor:any = "";
  idUsuario:any = "";
  tipoUsuario:any = ""
  
  constructor(public http:HttpClient){
    this.idServidor = localStorage.getItem("idServidor");
    this.idUsuario = localStorage.getItem("idUserVM");
  }

  getLoginByUsuario(cpf:any,empresa:any){
    return this.http.get(this.apiAssociados+'?filtro={"$or":[{"cpf":"'+cpf+'"},{"dependentes.cpf":"'+cpf+'"},{"dependentesExtra.cpf":"'+cpf+'"}],"empresa":"'+empresa+'","situacao":{"$not":{"$regex":"CANCELADO","$options":"i"}}}&sort={"empresa":-1}');
  }

  getServidorLogin(cpf:any){
    return this.http.get(this.apiServidores+'?filtro={"$or":[{"cpf":"'+cpf+'"},{"dependentes.cpf":"'+cpf+'"},{"dependentesExtra.cpf":"'+cpf+'"},{"servicos.dependentes.cpf":"'+cpf+'"}],"situacao":{"$not":{"$regex":"CANCELADO","$options":"i"}}}');
  }
 
  getLoginByEmpresa(cnpj:any, pwd:any){
    return this.http.get(this.apiEmpresas+'?filtro={"cnpj":"'+cnpj+'","senha":"'+pwd+'"}')
  }

  getConfigs(){
    return this.http.get(this.apiConfiguracoes+'?sort={"_id":1}');
  }

  getAllUsuarios(){
    return this.http.get(this.apiUsuarios+'?project={"email":1,"nome":1}');
  }

  getCredenciados(){
    return this.http.get(this.apiCredenciados+'?filtro={"situacao":"ATIVO"}')
  }

  getCredenciadosById(id:any){
    return this.http.get(this.apiCredenciados+'/'+id);
  }

  getServidorById(id:any){
    return this.http.get(this.apiServidores+'/'+id);
  }

  getCredenciadosCidadeEspecialidade(cid:any,esp:any){
    if(esp == 'LABORATORIO'){
      return this.http.get(this.apiCredenciados+'?filtro={"situacao":"ATIVO","municipio":{"$regex":"'+cid+'","$options":"i"},"$or":[{"laboratorioCheck":true},{"especialidade":{"$regex":"'+esp+'","$options":"i"}},{"profissionais.especialidade":{"$regex":"'+esp+'","$options":"i"}}]}&sort={"fantasiaCredenciado":1}');
    }else{
      return this.http.get(this.apiCredenciados+'?filtro={"situacao":"ATIVO","municipio":{"$regex":"'+cid+'","$options":"i"},"$or":[{"especialidade":{"$regex":"'+esp+'","$options":"i"}},{"profissionais.especialidade":{"$regex":"'+esp+'","$options":"i"}}]}&sort={"fantasiaCredenciado":1}');
    }
   }

  getAssociadosById(id:any){
    return this.http.get(this.apiAssociados+'/'+id);
  }

  getAssociadosMatricula(key:any){
    return this.http.get(this.apiAssociados+'?filtro={"matricula":'+key+',"$and":[{"$or":[{"empresa":"VIVA MAX"},{"empresa":"SEGUROS"},{"empresa":"CONECTA"}]},{"situacao":{"$not":{"$regex":"CANCELADO","$options":"i"}}}]}&sort={"nome":1}');}  

  getAssociadosCpf(cpf:any){
    return this.http.get(this.apiAssociados+'?filtro={"cpf":"'+cpf+'","$and":[{"$or":[{"empresa":"VIVA MAX"},{"empresa":"SEGUROS"},{"empresa":"CONECTA"}]},{"situacao":{"$not":{"$regex":"CANCELADO","$options":"i"}}}]}&sort={"nome":1}');
  }

  getLoginCpf(cpf:any){
    return this.http.get(this.apiAssociados+'?filtro={"$and":[{"$or":[{"empresa":"VIVA MAX"},{"empresa":"SEGUROS"},{"empresa":"CONECTA"}]},{"$or":[{"cpf":"'+cpf+'"},{"dependentes.cpf":"'+cpf+'"},{"dependentesExtra.cpf":"'+cpf+'"}]}],"situacao":{"$not":{"$regex":"CANCELADO","$options":"i"}}}&project={"senha":1,"ultimoAcesso":1,"empresa":1,"matricula":1,"cpf":1,"nome":1,"dependentes.cpf":1,"dependentes.nome":1,"dependentes.ultimoAcesso":1,"dependentesExtra.cpf":1,"dependentesExtra.nome":1,"dependentesExtra.ultimoAcesso":1}&sort={"empresa":1}');
  }

  getLoginCnpj(cnpj:any){
    return this.http.get(this.apiEmpresas+'?filtro={"cnpj":"'+cnpj+'"}&project={"ultimoAcesso":1}');
  }

  getEmpresaSenha(codigoEmpresa:any, cnpj:any){
    return this.http.get(this.apiEmpresas+'?filtro={"codigo":"'+codigoEmpresa+'","cnpj":"'+cnpj+'"}&project={"fantasiaEmpresa":1}');
  }

  getAssociadosRecuperarSenha(cpf:any,matricula:any){
    return this.http.get(this.apiAssociados+'?filtro={"$and":[{"$or":[{"empresa":"VIVA MAX"},{"empresa":"SEGUROS"},{"empresa":"CONECTA"}]},{"$or":[{"cpf":"'+cpf+'"},{"dependentes.cpf":"'+cpf+'"},{"dependentesExtra.cpf":"'+cpf+'"}]}],"situacao":{"$not":{"$regex":"CANCELADO","$options":"i"}},"matricula":'+matricula+'}');
  }

  patchAssociado(id:any,dados:any){
    let body = JSON.stringify(dados);
    return this.http.patch(this.apiAssociados+'/'+id,body);
  }

  patchServidor(id:any,dados:any){
    let body = JSON.stringify(dados);
    return this.http.patch(this.apiServidores+'/'+id,body);
  }

 /*  createAgendaDependente(id:any,cpf:any){
    return this.http.get(this.apiAssociados+'&method=CREATEAGENDADEPENDENTE&id='+id+'&cpf='+cpf)
  }

  createAgendaDependenteExtra(id:any,cpf:any){
    return this.http.get(this.apiAssociados+'&method=CREATEAGENDADEPENDENTEEXTRA&id='+id+'&cpf='+cpf)
  }
 

  patchDependenteSenha(id:any,idDependente:any,dados:any){
    let body = JSON.stringify(dados);
    return this.http.patch(this.apiAssociados+'/'+id+'/dependentes/'+idDependente,body);
  }

  patchDependenteSenhaServidor(id:any,idxServico:any, idxDependente:any, dados:any){
    let body = JSON.stringify(dados);
    return this.http.get(this.apiServidores+'&method=PATCHSENHADEPSERVIDOR&id='+id+'&idxServico='+idxServico+'&idxDependente='+idxDependente+'&body='+body);
  }*/

  envioSMSRecuperacao(numero,codigo){
    let msg = "Viva Max - Seu Código de Recuperação de Senha: "+codigo;
    let objRequest = {
      numero:numero,
      mensagem:msg
    }
    let str = JSON.stringify(objRequest);
    return this.http.post(this.apiSMS + '/enviar', str);
  }

  getCidadesConfig() {
    return this.http.get(this.apiConfiguracoes + '/60bff57c2a858830307fa57d');
  }

  getEspecialidadesConfig() {
    return this.http.get(this.apiConfiguracoes + '/60a268167800532d64f719a5');
  }
 
  getPlanosByTipoByNome(tipo,nome){
    return this.http.get(this.apiPlanos+'?filtro={"tipo":"'+tipo+'","nome":"'+nome+'"}');
  }

  newHistorico(id:any,dados:any){
    let body = JSON.stringify(dados);
    return this.http.post(this.apiAssociados+'/'+id+'/historicos',body);
  }

  postLogs(dados:any){
    let body = JSON.stringify(dados);
    return this.http.post(this.apiLogs+'/',body);
  }

  getFormularios(){
    return this.http.get(this.apiFormularios);
  }

  getCep(cep:any){
    return this.http.get('https://viacep.com.br/ws/'+cep+'/json/');
  }

  patchEmpresa(id:any,dados:any){
    let body = JSON.stringify(dados);
    return this.http.patch(this.apiEmpresas+'/'+id,body)
  }

  getAssociadosByCodigoEmpresa(codigo:any){
    return this.http.get(this.apiAssociados+'?filtro={"codigoEmpresa":"'+codigo+'","$and":[{"$or":[{"empresa":"VIVA MAX"},{"empresa":"CONECTA"}]}]}')
  }
  
  getEmpresasById(id:any){
    return this.http.get(this.apiEmpresas+'/'+id);
  }

  getEmpresaByCodigo(codigo:any){
    return this.http.get(this.apiEmpresas+'?filtro={"codigo":"'+codigo+'"}')
  }

  getPlanosEmpresariais(){
    return this.http.get(this.apiPlanos+'?filtro={"tipo":"PLANO EMPRESARIAL"}');
  }

  cadastroProposta(dados:any){
    let body = JSON.stringify(dados);
    return this.http.post(this.apiAssociados,body);
  }

  patchMatricula(id:any,dados:any){
    let body = JSON.stringify(dados);
    return this.http.patch(this.apiConfiguracoes+'/'+id,body);
  }

  getFinanceiro(key:any){
    return this.http.get(this.apiFinanceiro+'?filtro={"favorecido":"'+key+'","tipo":"Entrada"}');
  }

  getFinanceiroByIdUser(key:any){
    return this.http.get(this.apiFinanceiro+'?filtro={"idUser":"'+key+'","tipo":"Entrada"}');
  }
  
  postTarefa(dados:any){
    let body = JSON.stringify(dados);
    return this.http.post(this.apiUsuarios+'/'+dados.idResponsavel+'/tarefas',body);
  }

  postEvento(dados:any){
    let body = JSON.stringify(dados);
    return this.http.post(this.apiAssociados+'/'+dados.idUser+'/agenda',body);
  }

  /* postEventoDependente(idTitular:any,cpf:any,dados:any){
    let body = JSON.stringify(dados);
    return this.http.get(this.apiAssociados+'&method=POSTAGENDADEPENDENTE&id='+idTitular+'&cpf='+cpf+'&body='+body);
  }

   postEventoDependenteExtra(idTitular:any,cpf:any,dados:any){
    let body = JSON.stringify(dados);
    return this.http.get(this.apiAssociados+'&method=POSTAGENDADEPENDENTEEXTRA&id='+idTitular+'&cpf='+cpf+'&body='+body);
  } */

  patchEvento(idUser:any,idAgenda:any,dados:any){
    let body = JSON.stringify(dados);
    return this.http.patch(this.apiAssociados+'/'+idUser+'/agenda/'+idAgenda,body);
  }
/* 
  patchEventoDependente(idTitular:any,cpf:any,idAgenda:any,dados:any,indice:any){
    let body = JSON.stringify(dados);
    return this.http.get(this.apiAssociados+'&method=PATCHAGENDADEPENDENTE&id='+idTitular+'&cpf='+cpf+'&idAgenda='+idAgenda+'&body='+body+'&indice='+indice);
  }

  patchEventoDependenteExtra(idTitular:any,cpf:any,idAgenda:any,dados:any,indice:any){
    let body = JSON.stringify(dados);
    return this.http.get(this.apiAssociados+'&method=PATCHAGENDADEPENDENTEEXTRA&id='+idTitular+'&cpf='+cpf+'&idAgenda='+idAgenda+'&body='+body+'&indice='+indice);
  } */

  deleteEvento(idUser:any,idAgenda:any){
    return this.http.delete(this.apiAssociados+'/'+idUser+'/agenda/'+idAgenda);
  }

/*   deleteEventoDependente(idTitular:any,cpf:any,idAgenda:any){
    return this.http.delete(this.apiAssociados+'&method=DELETEAGENDADEPENDENTE&id='+idTitular+'&cpf='+cpf+'&idAgenda='+idAgenda);
  }

  deleteEventoDependenteExtra(idTitular:any,cpf:any,idAgenda:any){
    return this.http.get(this.apiAssociados+'&method=DELETEAGENDADEPENDENTEEXTRA&id='+idTitular+'&cpf='+cpf+'&idAgenda='+idAgenda);
  } */

  postAssinante(dados){
     let options = { headers: {'api_key': 'ak_sandbox_7c23696c5ec2eb4a880d7b5457aa42807a60f9b5'} };
    return this.http.post('https://api-sandbox.cyclopay.com/v1/subscriptions',dados,options); 
  }
  
  enviarEmailOutros(arquivo:any,replyto:any,nome:any,mensagem:any,assunto:any){
    let url = this.urlSite+'/email.php?replyto='+replyto+'&nome='+nome+'&mensagem='+mensagem+'&assunto='+assunto;
    return this.http.post(url,arquivo);
  }

  sendEmailCancelamento(email,emailVM,matricula,protocolo,nome,nomeTitular,telefone,motivo,anexos){
    let url = this.urlSite+'/sendMailCancelamento.php?email='+email+'&emailVM='+emailVM+'&nome='+nome+'&nomeTitular='+nomeTitular+'&motivo='+motivo+'&matricula='+matricula+'&protocolo='+protocolo+'&telefone='+telefone;
    return this.http.post(url,anexos);
  }

  sendEmailSac(email,emailVM,matricula,nome,nomeTitular,telefone,texto,tipoSac){
    let url = this.urlSite+'/sendMailSac.php?email='+email+'&emailVM='+emailVM+'&nome='+nome+'&nomeTitular='+nomeTitular+'&tipoSac='+tipoSac+'&matricula='+matricula+'&texto='+texto+'&telefone='+telefone;
    return this.http.get(url);
  }

  sendEmailReembolso(email,emailVM,matricula,nomeTitular,nome,telefone,tipoReembolso,valorReembolso,anexos){
    let url = this.urlSite+'/sendMailReembolso.php?email='+email+'&emailVM='+emailVM+'&nome='+nome+'&nomeTitular='+nomeTitular+'&tipoReembolso='+tipoReembolso+'&matricula='+matricula+'&valorReembolso='+valorReembolso+'&telefone='+telefone;
    return this.http.post(url,anexos);
  }

  sendEmailSeguro(email,emailVM,matricula,nomeTitular,telefone,tipoSeguro,anexos){
    let url = this.urlSite+'/sendMailSeguro.php?email='+email+'&emailVM='+emailVM+'&nomeTitular='+nomeTitular+'&tipoSeguro='+tipoSeguro+'&matricula='+matricula+'&telefone='+telefone;
    return this.http.post(url,anexos);
  }

  sendEmailCarteirinha(array,endereco,email,emailVM,nomeTitular,valor){
    let url = this.urlSite+'/sendMailCarteirinhas.php?array='+JSON.stringify(array)+'&endereco='+JSON.stringify(endereco)+'&email='+email+'&emailVM='+emailVM+'&nomeTitular='+nomeTitular+'&valor='+valor;
    return this.http.get(url);
  }

  enviarInclusaoExclusaoDependentes(email,emailVM,celular,nomeTitular,tipoAlteracao,matricula,dependentes){  
    let url = this.urlSite+'/sendMailDependentes.php?email='+email+'&emailVM='+emailVM+'&celular='+celular+'&nomeTitular='+nomeTitular+'&tipoAlteracao='+tipoAlteracao+'&matricula='+matricula+'&dependentes='+JSON.stringify(dependentes);
    return this.http.get(url);
  }

  enviarAlteraracaoDependentes(email,emailVM,celular,nomeTitular,tipoAlteracao,matricula,dependenteAlterado,dependenteOriginal){  
    let url = this.urlSite+'/sendMailDependentesAlterar.php?email='+email+'&emailVM='+emailVM+'&celular='+celular+'&nomeTitular='+nomeTitular+'&tipoAlteracao='+tipoAlteracao+'&matricula='+matricula+'&dependenteAlterado='+JSON.stringify(dependenteAlterado)+'&dependenteOriginal='+JSON.stringify(dependenteOriginal);
    return this.http.get(url);
  }
  
  enviarDocAssociado(id:any,imagedata:any){
    let url = this.urlSite+'/upload-doc-associado.php?id='+id;
    return this.http.post(url, imagedata);
  }

}

